import { SearchType } from '@/app/(site)/search/types'
import {
    defaultMobileOffset,
    getCarouselOffset,
    getClickableAdOffset,
    getVideoOffset,
} from '@/app/components/spotlight-grid/spotlight-util'
import { ctaSectionHeightWithGap } from '@/app/components/spotlight-or-video-grid/clickable-ad'
import { IGif } from '@giphy/js-types'
import { getGifHeight } from '@giphy/js-util'
import { useMemo } from 'react'

type Props = {
    clickableAdGif: IGif | null
    spotlightGif: IGif | null
    includeSpotlight: boolean
    isMobile: boolean
    windowWidth: number
    type: SearchType
    clientRender: boolean
}

export function useAdOffsets({
    clickableAdGif,
    spotlightGif,
    includeSpotlight,
    isMobile,
    windowWidth,
    type,
    clientRender,
}: Props) {
    const offset = useMemo(() => {
        if (clickableAdGif) {
            return isMobile
                ? getGifHeight(clickableAdGif, windowWidth / 2) + ctaSectionHeightWithGap
                : getClickableAdOffset(clickableAdGif)
        }

        if (spotlightGif) {
            return spotlightGif.video ? getVideoOffset(spotlightGif) : getCarouselOffset(spotlightGif)
        }

        return 0
    }, [clickableAdGif, isMobile, windowWidth, spotlightGif])

    const columnOffsets = useMemo(() => {
        if (includeSpotlight) {
            return [0, 0, offset, offset]
        }

        if (clickableAdGif && type === 'gifs') {
            if (isMobile) {
                return clientRender ? [offset, 0] : [defaultMobileOffset, 0]
            }
            return [offset, 0, 0, 0]
        }

        return undefined
    }, [includeSpotlight, clickableAdGif, type, isMobile, clientRender, offset])

    return { offset, columnOffsets }
}
